var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "monthListScroller",
      staticClass: "calendar-scroll-months",
      style: [
        { height: _vm.monthListHeight ? _vm.monthListHeight + "px" : "auto" },
      ],
      attrs: { "data-component": "calendar-scroll-date-select" },
      on: { scroll: _vm.handleScroll },
    },
    _vm._l(_vm.monthsRendered, function (month) {
      return _c("calendar-month", {
        key: month.month,
        attrs: {
          id: month.month,
          month: month.month,
          "days-in-month": month.daysInMonth,
          "input-selected": _vm.inputSelected,
          "is-visible": _vm.monthsInView.includes(month.month),
        },
        on: {
          "month-click": function ($event) {
            return _vm.$emit("month-click")
          },
          "day-selected": function ($event) {
            return _vm.$emit("day-selected")
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }